<template>
  <div class="enquiry">
    <div>
      <p class="site_eyebrow site_eyebrow--accent">Zapytanie o auto</p>
      <h2>Powiedz nam, czego szukasz – odezwiemy się w ciągu 24 godzin.</h2>
      <p class="enquiry_lead">
        Marka, model, rocznik, budżet — albo numer aukcji. Przygotujemy szczegółową wycenę
        bez ukrytych pozycji.
      </p>
      <p class="enquiry_phones">
        <a href="tel:+48509230500"><PhoneIcon /> Tel. 509 230 500</a>
        <a href="tel:+48501069442"><PhoneIcon /> Tel. 501 069 442</a>
      </p>
    </div>

    <SiteContactForm />
  </div>
</template>

<script>
// The black "tell us what you are looking for" panel that closes several pages.

import SiteContactForm from '@/components/SiteContactForm.vue'
import PhoneIcon from '@/components/icons/PhoneIcon.vue'

export default {
  name: 'SiteEnquiry',
  components: { SiteContactForm, PhoneIcon },
}
</script>

<style scoped>
.enquiry {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;
  padding: 48px 32px;
  border-radius: var(--radius);
  background: var(--ink);
  color: var(--ink-invert-soft);
}

.enquiry h2 {
  margin: 15px 0 22.5px;
  color: var(--ink-invert);
}

.enquiry_lead {
  max-width: 486px;
  margin-bottom: 32px;
}

.enquiry_phones {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  color: #fff;
}

.enquiry_phones a {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

@media (max-width: 1024px) {
  .enquiry {
    grid-template-columns: 1fr;
    gap: 32px;
  }
}

@media (max-width: 600px) {
  .enquiry {
    padding: 32px 20px;
  }
}
</style>
